import { render, staticRenderFns } from "./PcBannerScore.vue?vue&type=template&id=b2960658&scoped=true"
import script from "./PcBannerScore.vue?vue&type=script&lang=js"
export * from "./PcBannerScore.vue?vue&type=script&lang=js"
import style0 from "./PcBannerScore.vue?vue&type=style&index=0&id=b2960658&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2960658",
  null
  
)

export default component.exports